<template>
  <div>
    <vx-card no-shadow class="mt-5">
      <div class="px-2">
        <div class="flex justify-between mt-5">
          <div class="text-2xl font-medium">Task</div>
          <a-dropdown>
            <a-menu slot="overlay">
              <a-menu-item v-if="hasPermission('task.list')" key="1" @click="addTAskType">Task types</a-menu-item>
              <a-menu-item v-if="hasPermission('task.create')" key="2" @click="addTAsk">New task</a-menu-item>
            </a-menu>
            <a-button type="primary" style="margin-left: 8px;border-radius: 3px !important;">New <a-icon type="down" /></a-button>
          </a-dropdown>
        </div>
        <div class="flex flex-col md:flex-row items-center md:justify-between my-5">
          <div class="flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0">
            <a-select
              default-value="all"
              @select="filterStatus($event,'status','=')"
              placeholder="Task status"
              style="width: 250px"
              allow-clear
            >
              <a-select-option value="all">
                All
              </a-select-option>
              <a-select-option value="1">
                Pending
              </a-select-option>
              <a-select-option value="2">
                In progress
              </a-select-option>
              <a-select-option value="3">
                In review
              </a-select-option>
              <a-select-option value="4">
                Complete
              </a-select-option>
            </a-select>
            <a-select
              placeholder="Select a Time estimate"
              style="width: 250px"
              allowClear
              class="select"
              @select="filterStatus($event,'time_estimate','isnull')"
            >
              <a-select-option value="all">
                All
              </a-select-option>
              <a-select-option :value="false">
                With time entries
              </a-select-option>
              <a-select-option :value="true">
                Without time entries
              </a-select-option>
            </a-select>
          </div>
        </div>
      </div>
      <a-tabs default-active-key="1" @change="handleTabsKanbanOrList">
          <template #tabBarExtraContent>
            <div class="flex items-center gap-2">
              <ChipCustomizeCloseClearChipIcon
                v-if="$refs.task"
                :items="hasFilterMatter ? null : $refs.task.query.query"
                :data="{
                    practice_area: $refs.practiceArea ? $refs.practiceArea.data : [],
                    responsible  : $refs.users        ? $refs.users.data        : [],
                    groups       : $refs.permissions  ? $refs.permissions.data  : [],
                    contacts     : $refs.listContacts ? $refs.listContacts.rows : [],
                    matter       : $refs.matter       ? $refs.matter.matters    : []
                }"
                @deleteFilter="deleteFilter"
              />
              <a-button type="primary"
                        ghost
                        icon="filter"
                        @click="showDrawer"
                        style="border-radius: 3px !important;"
              >
                <template #icon>
                  <feather-icon icon="FilterIcon" svg-classes="text-primary w-4 h-4"></feather-icon>
                </template>
                Filter And Export
              </a-button>
            </div>
          </template>
          <a-tab-pane key="1" tab="List">
            <XTable
            class="mt-3"
            :model="model"
            ref="task"
            :options="{placeholder:'Search task',noContent: 'No tasks',is_row_selection: false,is_load_req: false}"
            @clickRow="clickTempRow"
          >
            <span slot="action" slot-scope="text,record" class="flex space-x-3">
                  <a-dropdown>
                    <a-menu slot="overlay">
                      <a-menu-item v-if="hasPermission('task.get')" key="1" @click="editTask(text.record)"> <feather-icon icon="EditIcon" svg-classes="text-success w-4 h-4" class="pr-2"/>Edit</a-menu-item>
                      <a-menu-item v-if="hasPermission('task.delete')" key="2" @click="deleteTask(text.record)"> <feather-icon icon="TrashIcon" svg-classes="text-danger w-4 h-4" class="pr-2"/>Delete</a-menu-item>
                    </a-menu>
                    <a-button style="margin-left: 8px" @click="is_click_add_time = false"> Actions <a-icon type="down" /> </a-button>
                  </a-dropdown>
              </span>
            <span slot="status" slot-scope="text,record,index">
              <a-dropdown>
                <a-menu slot="overlay">
                  <a-menu-item :key="1" @click="changeStatusTask(text.record,1)">Pending</a-menu-item>
                  <a-menu-item :key="2" @click="changeStatusTask(text.record,2)">In progress</a-menu-item>
                  <a-menu-item :key="3" @click="changeStatusTask(text.record,3)">In review</a-menu-item>
                  <a-menu-item :key="4" @click="changeStatusTask(text.record,4)">Complete</a-menu-item>
                </a-menu>
                <a-button size="default" ghost :style="styleStatusTask(text.record.status)" @click="is_click_add_time = false"> {{ currentTaskStatus(text.record.status) }} <a-icon type="down" /></a-button>
              </a-dropdown>
            </span>
            <span slot="priority" slot-scope="text,record">
                      <template v-if="text.record.priority === 1">
                        Low
                      </template>
                      <template v-else-if="text.record.priority === 2">
                        Normal
                      </template>
                      <template v-else>
                        High
                      </template>
                </span>
            <span slot="assigned" slot-scope="text,record" v-if="text.record.assigned_user">
                  {{ text.record.assigned_user.first_name }} {{ text.record.assigned_user.last_name }}
            </span>
            <span slot="time" slot-scope="text,record" v-if="text.record.time_estimate">
                  {{ text.record.time_estimate + "h" }}
            </span>
            <span slot="matter" slot-scope="text,record" v-if="text.record.matter">
                  {{ text.record.matter.title }}
            </span>
            <span slot="task_type" slot-scope="text,record" v-if="text.record.task_type">
                  {{ text.record.task_type.title }}
            </span>
            <span slot="contact" slot-scope="text,record" v-if="text.record.matter">
                  <template v-if="text.record.matter.client">
                      <template v-if="text.record.matter.client.person">
                        {{ text.record.matter.client.person.first_name }} {{ text.record.matter.client.person.last_name }}
                      </template>
                      <template v-else>
                        {{ text.record.matter.client.company.name }}
                      </template>
                  </template>
            </span>
            <span slot="record" slot-scope="text,record">
              <a-button type="primary" ghost icon="caret-right" @click="modalAddTime(text.record)" style="border-radius: 3px !important;">
<!--                <template slot="icon">-->
<!--                  <feather-icon icon="PlayIcon" svg-classes="text-primary w-4 h-4" />-->
<!--                </template>-->
                Add Time
              </a-button>
            </span>
            <span slot="due_date" slot-scope="text,record">
              {{ setDateFormat(text.record.due_date) }}
            </span>
            <span slot="task_title" slot-scope="text,record">
              <a-popover>
                <template slot="content">
                  <p>{{ text.record.title }}</p>
                </template>
                <p style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden; width: 25rem;">
                  {{ text.record.title }}
                </p>
              </a-popover>
            </span>
          </XTable>
          </a-tab-pane>
          <a-tab-pane key="2" tab="Kanban" :class="loading ? 'pb-5':'pb-0'">
            <ASpin :spinning="loading" :indicator="indicator">
              <div :class="loading ? 'p-5':''" class="flex flex-col md:flex-row justify-center overflow-x-scroll">
                  <div
                    v-for="column in columns"
                    :key="column.title"
                    class="bg-gray-100 rounded-lg px-3 py-3 column-width rounded w-full"
                  >
                    <p class="text-gray-700 font-semibold font-sans tracking-wide text-sm">{{column.title}}</p>
                    <a-divider/>
                    <draggable :list="column.tasks" :animation="200" ghost-class="ghost-card" group="tasks">
                      <task-card
                        v-for="(task) in column.tasks"
                        :key="task.id"
                        :task="task"
                        class="mt-3 cursor-move"
                        @editKanbanItem="editKanbanItem"
                      ></task-card>
                    </draggable>
                    <!--                  <template v-else>-->
                    <!--                    <a-card>-->
                    <!--                      <a-empty/>-->
                    <!--                    </a-card>-->
                    <!--                  </template>-->
                  </div>
                </div>
            </ASpin>
          </a-tab-pane>
      </a-tabs>
    </vx-card>
    <vs-card v-show="false" class="py-5 mt-5">
      <div class="container mx-auto text-center">
        <img src="../../../public/todo.svg" width="300">
        <h2>You hevent created any task list.</h2>
        <p class="text-base font-medium">
          Click <a href="#">here</a> or use the button in the bott Add Task Listom to create a new task list.
        </p>
        <vs-button color="primary" type="filled" class="font-bold" @click="addTAsk">Add task list</vs-button>
      </div>
    </vs-card>
    <a-modal centered class="task" :visible="openTask" :width="700" title="New task" @cancel="onCancel">
      <a-form :form="form" @submit.prevent="handleTask">
        <h4>Details</h4>
        <div class="flex flex-col md:flex-row space-x-0 md:space-x-4">
          <div class="w-full md:w-3/5 flex-grow">
            <a-form-item label="Task Name" has-feedback>
              <a-input
                v-decorator="['title',{ rules: [{ required: true, message: 'This field is required.' }] }]"
                placeholder="Enter task name..."
              />
            </a-form-item>
          </div>
          <div class="w-full md:w-2/5">
            <a-form-item label="Priority" has-feedback>
              <a-select
                style="width: 100%;border-radius: 3px !important;"
                default-value="1"
                allowClear
                v-decorator="['priority',{ rules: [{ required: false, message: 'Please input your Task Name!' }] }]"
              >
                <a-select-option value="1">
                  Low
                </a-select-option>
                <a-select-option value="2">
                  Normal
                </a-select-option>
                <a-select-option value="3">
                  High
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>
        </div>
        <a-form-item label="Description" has-feedback>
          <a-textarea
            v-decorator="['description',{ rules: [{ required: false, message: 'Please input your username!' }] }]"
            placeholder="Enter task description..."
          />
        </a-form-item>
        <div class="flex flex-col md:flex-row w-full space-x-0 md:space-x-4">
          <SelectOption url="/account/list/" label="Assignee" field="assigned_user" :required="true" method="get" placeholder="Select an assignee" class="w-full md:w-1/2"/>
          <SelectOption url="/task/task-type/query/" label="Task type" field="task_type" :required="false" placeholder="Find a task type..." class="w-full md:w-1/2"/>
        </div>
        <div class="flex flex-col md:flex-row w-full space-x-0 md:space-x-4">
          <a-form-item has-feedback label="Task status" class="w-full md:w-1/2">
            <a-select
              default-value="1"
              v-decorator="['status',{ initialValue: '1',rules: [{ required: false, message: 'Please input your Task Name!' }] }]"
            >
              <a-select-option value="1">
                Pending
              </a-select-option>
              <a-select-option value="2">
                In progress
              </a-select-option>
              <a-select-option value="3">
                In review
              </a-select-option>
              <a-select-option value="4">
                Complete
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item class="w-full md:w-1/2" has-feedback>
            <span slot="label">
              Time estimate
              <a-popover title="Help" placement="right">
                <template slot="content">
                  <h6>Which time formats can I use?</h6>
                  <p class="text-sm">IRALEX allows for a variety of duration formats to suit your needs</p>
                  <p>Examples</p>
                  <p class="text-sm">1h 12m, 1:12, 72min, 20h</p>
                </template>
                <span slot="title">Title</span>
                <a-icon type="question-circle-o" theme="twoTone" two-tone-color="#3A3DBE" class="cursor-pointer" />
              </a-popover>
            </span>
            <a-input
              v-decorator="['time_estimate',{ initialValue: null,rules: [{ required: false, message: '' }] }]"
              placeholder="EX 1h 12m, 1:12, 72min, 20h"
              @change="handleTime"
              @blur="handleTime"
            />
          </a-form-item>
        </div>

        <selectSearch
          :required="false"
          url="/matter/query/"
          :options="optionSearchMatter"
          field="matter"
          label="Matter"
          class="self-center md:mt-0 w-full"
          :is_include_matter="true"
          @selectSearch="handleSearch"
        />

        <a-divider/>

        <h4>Due date</h4>

        <a-form-item label="Select date" has-feedback>
          <a-date-picker
            v-decorator="['due_date',{rules: [{ required: false, message: '' }] }]"
            placeholder="dd/mm/yyyy"
            :format="dateFormat"
            valueFormat="YYYY-MM-DD"
          />
        </a-form-item>

        <a-divider/>

        <RemindersComponent
          ref="reminder"
          :isReminderTask="true"
          @addReminder="addReminder"
          @removeReminder="removeReminder"
          @changeOptionDate="handleChangeDate"
        />

<!--        <h4>Reminder</h4>-->
<!--        <div v-for="(reminder,ind) in reminders">-->
<!--          <div class="flex flex-col md:flex-row md:gap-4 w-full">-->
<!--            <a-form-item label="Option date" has-feedback>-->
<!--              <a-select-->
<!--                v-decorator="[`reminders[${ind}].option_date`,{ rules: [{ required: false }] }]"-->
<!--                @change="(value) => handleChangeDate(value,ind)"-->
<!--                style="width: 150px"-->
<!--              >-->
<!--                <a-select-option :value="1">1 days</a-select-option>-->
<!--                <a-select-option :value="2">2 days</a-select-option>-->
<!--                <a-select-option :value="3">3 days</a-select-option>-->
<!--                <a-select-option :value="4">4 days</a-select-option>-->
<!--                <a-select-option :value="7">1 weeks</a-select-option>-->
<!--                <a-select-option :value="14">2 weeks</a-select-option>-->
<!--              </a-select>-->
<!--            </a-form-item>-->
<!--            <a-form-item label="Target date" has-feedback>-->
<!--              <a-date-picker-->
<!--                v-decorator="[`reminders[${ind}].target_date`,{rules: [{ required: false }] }]"-->
<!--                :format="dateFormat"-->
<!--                placeholder="dd/mm/yyyy"-->
<!--              />-->
<!--            </a-form-item>-->
<!--            <a-form-item class="w-full md:w-1/2" label="Notification type" has-feedback>-->
<!--              <a-select-->
<!--                v-decorator="[`reminders[${ind}].notification_type`,{ rules: [{ required: false}] }]"-->
<!--                placeholder="Select Type Notification"-->
<!--              >-->
<!--                <a-select-option :value="1">-->
<!--                  Notification-->
<!--                </a-select-option>-->
<!--                <a-select-option :value="2">-->
<!--                  Email-->
<!--                </a-select-option>-->
<!--                <a-select-option :value="3">-->
<!--                  Both-->
<!--                </a-select-option>-->
<!--              </a-select>-->
<!--            </a-form-item>-->
<!--            <feather-icon-->
<!--                icon="MinusCircleIcon"-->
<!--                @click="removeReminder(ind)"-->
<!--                svg-classes="text-danger"-->
<!--                class="self-end cursor-pointer mb-4"-->
<!--            />-->
<!--          </div>-->
<!--        </div>-->
<!--        <a-button type="primary" ghost shape="circle" icon="plus" class="plus-icon mt-5" @click="addReminder(reminders)"/>-->

        <div v-if="hasPermission('task.edit')" id="task-footer">
          <a-divider/>
          <div class="flex space-x-2">
            <a-button type="primary"  style="border-radius: 3px" html-type="submit">Save task</a-button>
            <a-button type="primary" ghost style="border-radius: 3px" @click="openTask = false">Cancel</a-button>
          </div>
        </div>

      </a-form>
    </a-modal>
    <deleteItem
      :url="`/task/${temp_row}/`"
      subject="Task"
      :ele="$refs.task"
      ref="taskDelete"
    />
    <Drawer ref="drawer"
            :form="formFilter"
            :ele="$refs.task"
            :query="[
                { field : 'title'        , value : formFilter.getFieldValue('title')        ,  condition: formFilter.getFieldValue('condition_subject') },
                { field : 'due_date'     , value : formFilter.getFieldValue('from_due_date'),  condition: '>=' },
                { field : 'due_date'     , value : formFilter.getFieldValue('to_due_date')  ,  condition: '<=' },
                { field : 'matter'       , value : formFilter.getFieldValue('matter')       ,  condition: '=' },
                { field : 'priority'     , value : formFilter.getFieldValue('priority')     ,  condition: '=' },
                { field : 'task_type'    , value : formFilter.getFieldValue('task_type')    ,  condition: '=' },
                { field : 'time_estimate', value : formFilter.getFieldValue('time_estimate'),  condition: 'isnull' },
                { field : 'assigned_user', value : formFilter.getFieldValue('assigned_user'),  condition: '=' },
                { field : 'matter__client',value : formFilter.getFieldValue('client')       ,  condition: '=' },
                { field : 'matter__responsible',value : formFilter.getFieldValue('responsible'),  condition: '=' },
            ]"
    >
      <template>
        <div class="flex space-x-4">
          <a-form-item label="Condition" has-feedback>
            <a-select
              allowClear
              @change="(e) => handleRemoveSelect(e,'title',formFilter)"
              class="select"
              v-decorator="['condition_subject',{ initialValue: '=' }]"
              style="width: 150px"
            >
              <a-select-option value="=">
                Equal
              </a-select-option>
              <a-select-option value="like">
                Like
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Task" has-feedback>
            <a-input
              v-decorator="['title']"
              placeholder="title"
              autocomplete="none"
            />
          </a-form-item>
        </div>
        <a-divider/>
        <div class="flex space-x-4">
<!--          <a-form-item label="Condition" has-feedback>-->
<!--            <a-select-->
<!--              allowClear-->
<!--              @change="(e) => handleRemoveSelect(e,'due_date')"-->
<!--              class="select"-->
<!--              v-decorator="['condition',{ initialValue: '=' }]"-->
<!--              style="width: 150px"-->
<!--            >-->
<!--              <a-select-option value="=">-->
<!--                Equal-->
<!--              </a-select-option>-->
<!--              <a-select-option value=">">-->
<!--                Greater-->
<!--              </a-select-option>-->
<!--              <a-select-option value="<">-->
<!--                Less-->
<!--              </a-select-option>-->
<!--              <a-select-option value="<=">-->
<!--                Smaller than equal-->
<!--              </a-select-option>-->
<!--              <a-select-option value=">=">-->
<!--                Larger equals-->
<!--              </a-select-option>-->
<!--            </a-select>-->
<!--          </a-form-item>-->
          <a-form-item label="From due date" has-feedback>
            <a-date-picker
              v-decorator="['from_due_date']"
              :format="dateFormat"
              valueFormat="YYYY-MM-DD"
              class="w-full"
            />
          </a-form-item>
          <a-form-item label="To due date" has-feedback>
            <a-date-picker
              v-decorator="['to_due_date']"
              :format="dateFormat"
              valueFormat="YYYY-MM-DD"
              class="w-full"
            />
          </a-form-item>
        </div>
        <selectSearch
          ref="matter"
          :required="false"
          url="/matter/query/"
          :options="optionSearchMatter"
          field="matter"
          label="Matter"
          class="self-center mt-8 md:mt-0 w-full"
          :is_include_matter="true"
        />
        <a-form-item label="Priority" has-feedback>
          <a-select
            style="width: 100%;border-radius: 3px !important;"
            default-value="1"
            allowClear
            v-decorator="['priority',{ rules: [{ required: false, message: 'Please input your Task Name!' }] }]"
          >
            <a-select-option value="1">
              High
            </a-select-option>
            <a-select-option value="2">
              Normal
            </a-select-option>
            <a-select-option value="3">
              Low
            </a-select-option>
          </a-select>
        </a-form-item>
        <SelectOption url="/task/task-type/query/" label="Task type" field="task_type" :required="false" placeholder="Find a task type..."/>
        <SelectOption url="/account/list/" label="Assignee" field="assigned_user" :required="false" method="get" placeholder="Select an assignee" />
        <selectSearch
          ref="listContacts"
          :required="false"
          url="/contact/query/"
          :options="{ placeholder: 'Search contacts',label: 'Contacts',field: 'client',allow_clear: true }"
          class="self-center mt-8 md:mt-0 w-full"
        />
        <SelectOption ref="users" url="/account/list/" label="Responsible" field="responsible" :required="false" method="get" placeholder="Select an responsible" />
        <div
          :style="{
                  position: 'absolute',
                  left: 0,
                  bottom: 0,
                  width: '100%',
                  padding: '10px 16px',
                  background: '#fff',
                  textAlign: 'left',
                  zIndex: 1,
               }"
        >
          <div class="flex gap-2">
            <a-button type="primary" html-type="submit" style="border-radius: 3px !important">
              Save filter
            </a-button>
            <a-button type="primary" :loading="loadingExport" @click="exportTb" ghost style="border-radius: 3px !important">
              Export
            </a-button>
          </div>

        </div>
      </template>
    </Drawer>
    <ModalActivity ref="addTime" :taskId="taskIdRecordTime" />
  </div>
</template>

<script>

    import XTable from '../../components/x-table/XTable'
    import * as TableCol from './taskTbl'
    import mixin from '../mixin/mixin'
    import SelectOption from "../forms/SelectOptionSingle"
    import selectSearch from "@/views/forms/selectSearch";
    import deleteItem from '../communications/deleteItem'
    import axios from '@/axios'
    import Drawer from '../drawer/Drawer'
    import draggable from 'vuedraggable'
    import TaskCard from './kanban/TaskCard'
    import moment from 'moment'
    import ChipCustomizeCloseClearChipIcon from "@/views/components/vuesax/chip/ChipCustomizeCloseClearChipIcon";
    import ModalActivity from "@/views/modal/ModalActivity";
    import RemindersComponent from "@/views/reminders/RemindersComponent";

    export default {
      name:"TaskList",
      mixins:[mixin],
      props: {
        hasFilterMatter:{
          type: Boolean,
          default: false
        }
      },
      components:{
        RemindersComponent,
        ModalActivity,
        XTable,
        SelectOption,
        selectSearch,
        deleteItem,
        Drawer,
        draggable,
        TaskCard,
        ChipCustomizeCloseClearChipIcon
      },
      data() {
        return {
          model             : null,
          taskIdRecordTime  : null,
          openTask          : false,
          filter_assign_user: [],
          temp_row          : undefined,
          row               : undefined,
          result_time       : undefined,
          edit_mode         : false,
          type_status       : 'All',
          reminders         : [],
          radioStyle        : {display: 'block', height: '40px', lineHeight: '30px'},
          formProgress      : this.$form.createForm(this, {name: 'coordinated'}),
          formProductivity  : this.$form.createForm(this, {name: 'coordinated'}),
          formFilter        : this.$form.createForm(this, {name: 'coordinated'}),
          loading           : false,
          showAddTime       : false,
          columns           : [],
          handle_tabs       : '1'
        }
      },
      methods:{
        modalAddTime(record){
          this.is_click_add_time = false
          this.$refs.addTime.openActivities = true
          this.taskIdRecordTime = record.id
        },

        currentTaskStatus(sts){
          if (sts === 1) return 'Pending'
          if (sts === 2) return 'In progress'
          if (sts === 3) return 'In review'
          if (sts === 4) return 'Complete'
        },

        styleStatusTask(sts){
          if (sts === 1) return { borderColor: '#1890ff', color: '#1890ff' }
          if (sts === 2) return { borderColor: '#fa8c16', color: '#fa8c16' }
          if (sts === 3) return { borderColor: '#722ed1', color: '#722ed1' }
          if (sts === 4) return { borderColor: '#52c41a', color: '#52c41a' }
        },

        async changeStatusTask(record,sts) {
          try{
            this.$refs.task.loading = true
            const { assigned_user, description, due_date, priority, reminders, task_type, time_estimate, title } = record
            // const data = {
            //   assigned_user: assigned_user !== null ? assigned_user.id : undefined,
            //   description,
            //   due_date,
            //   priority,
            //   reminders,
            //   time_estimate,
            //   task_type: task_type ? task_type.id : null,
            //   title
            // }
            await axios.put(`/task/${record.id}/`,{status: sts})
            await this.$refs.task.fetch()
            this.$message.success('Status Changed.')
          }catch (e) {
            this.$message.error('Server Error')
            throw new Error(e)
          } finally {
            this.$refs.task.loading = false
          }
        },

        handleTabsKanbanOrList(key){
          this.handle_tabs = key
        },

        async deleteFilter(item){
          try {
            await this.$refs.task.fetch()
            this.form.resetFields(item.field.includes('__') ? item.field.split('__')[1] : item.field)
          }catch (e) {
            throw new Error(e)
          }
        },

        async getKanbanList(){
          try{
            this.loading = true
            const { data : { rows } } = await axios.post('/task/query/',{ limit: 9999 })
            const over_due      = [{ title : 'Over Due'   ,tasks: rows.filter(item => item.status !== 4 && this.overDueTasks(item.due_date)).sort((a,b) => moment.utc(b.due_date).diff(moment.utc(a.due_date)))}]
            const upcoming      = [{ title : 'Upcoming'   ,tasks: rows.filter(item => item.status !== 4 && this.upcomingTasks(item.due_date)).sort((a,b)=> moment.utc(b.due_date).diff(moment.utc(a.due_date)))}]
            const today         = [{ title : 'Today'      ,tasks: rows.filter(item => item.status !== 4 && this.TodayTasks(item.due_date)).sort((a,b)   => moment.utc(b.due_date).diff(moment.utc(a.due_date)))}]
            const no_due_date   = [{ title : 'No Due Date',tasks: rows.filter(item => item.due_date === null )}]
            const complete      = [{ title : 'Completed'  ,tasks: rows.filter(item => item.status === 4 )}]
            this.columns        = [...today,...over_due,...upcoming,...no_due_date,...complete]
          }catch (e) {
            this.$message.error('Error receiving data.')
            throw e
          }finally {
            this.loading = false
          }
        },

        overDueTasks(date){
          return date ? moment().format('YYYY-MM-DD') > moment(date).format('YYYY-MM-DD') : undefined
        },

        upcomingTasks(date){
          return date ? moment().format('YYYY-MM-DD') < moment(date).format('YYYY-MM-DD') : undefined
        },

        TodayTasks(date){
          return date ? moment().format('YYYY-MM-DD') === moment(date).format('YYYY-MM-DD') : undefined
        },

        taskReport(){
          this.$router.push('/task/report').catch(()=>{})
        },

        addReminder(){
          if (this.form.getFieldValue('due_date'))
            this.$refs.reminder.reminders.push({ target_date:undefined,notification_type: undefined })
          else this.$message.error('Please enter field due date.')
        },

        showDrawer(){
          this.$refs.drawer.visible_drawer = true
        },

        addTaskList(){
          this.$router.push('/task/lists')
        },

        deleteTask(record){
          this.temp_row = record.id
          this.$refs.taskDelete.open = true
        },

        addTAsk(){
          this.edit_mode = false
          this.openTask  = true
          const user     = JSON.parse(localStorage.getItem('user'))
          this.$nextTick(()=>{
            if(user) this.form.setFieldsValue({ assigned_user: user.id})
          })
        },

        addTAskType(){
          this.$router.push('/task/type')
        },

        onCancel(){
          this.openTask = false
          if(this.edit_mode){
            this.form.resetFields()
            this.$refs.reminder.reminders = []
          }
        },

        removeReminder(ind){
          const { form } = this;
          const reminders = form.getFieldValue('reminders')
          form.setFieldsValue({
            reminders: reminders.filter((reminder,index) => index !== ind)
          });
          this.$refs.reminder.reminders.splice(ind,1)
        },

        async filterStatus(value,field,condition){
          this.checkPagenation(this.$refs.task)
          value === 'all' ? this.$refs.task.query.query = undefined : this.$refs.task.query.query = [{ field:field,condition:condition,value: value }]
          await this.$refs.task.fetch()
        },

        async getRecordRow(record){
          try{
            this.$vs.loading()
            const { data } = await axios.get(`/task/${record.id}/`);
            this.row      =  data
            data.status   = `${data.status}`
            data.priority = `${data.priority}`
            if(data.time_estimate) data.time_estimate = `${data.time_estimate}h`
            data.matter ? data.matter = data.matter.title : data.matter = undefined
            data.assigned_user ? data.assigned_user = data.assigned_user.id : data.assigned_user = undefined
            data.task_type ? data.task_type = data.task_type.id : data.task_type = undefined
            this.result_time = undefined
            this.$refs.reminder.reminders = data.reminders.map(item=>({ target_date: item.target_date, notification_type: item.notification_type }))
            this.$nextTick(()=>this.form.setFieldsValue(data))
          }catch (e){
            this.$message.error('Server error')
          }finally {
            this.$vs.loading.close()
          }
        },

        editTask(record){
          this.edit_mode = true
          this.openTask  = true
          this.temp_row = record.id
          this.$nextTick(()=>{
            this.getRecordRow(record)
          })
        },

        editKanbanItem(task){
          this.clickTempRow(task)
        },

        clickTempRow(record){
          if (this.hasPermission('task.get')) {
            this.edit_mode = true
            if(this.is_click_add_time){
              this.openTask  = true
              this.temp_row = record.id
              this.$nextTick(()=>{
                this.getRecordRow(record)
              })
            }else
              this.is_click_add_time = true
          }
        },

        handleTask(){
          this.form.validateFields(async(err,values)=>{
            if(!err){
              try{
                this.$vs.loading()
                !values.time_estimate ? values.time_estimate = null : values.time_estimate = this.result_time
                if(values.reminders && values.reminders.length)
                  values.reminders = values.reminders.filter(reminder => reminder.notification_type !== undefined && reminder.target_date !== undefined )
                if(this.edit_mode){
                  this.matter_value ? values.matter = this.matter_value : !values.matter ? values.matter = null : values.matter = this.row.matter.id
                  const id = this.temp_row
                  await axios.put(`/task/${id}/`,values)
                }else {
                  await axios.post('/task/',values)
                }
                this.$vs.loading.close()
                this.result_time = null
                this.form.resetFields()
                this.openTask = false
                this.$refs.reminder.reminders = []
                this.$notification['success']({
                  message: 'Success',
                  description: `Task ${this.edit_mode ? 'updated' :'created'}.`,
                });
                await this.$refs.task.fetch()
                await this.getKanbanList()
              }catch (e) {
                this.$notification['error']({
                  message: 'Error',
                  description: `Please try again.`,
                });
                this.$vs.loading.close()
                this.openTask = true
                throw new Error(e)
              }
            }
          })
        },

        async exportTb() {
          try{
            this.loadingExport = true
            const columns = this.$refs.task.cols
            const columns_filtered = columns.filter((item)=> item.key !== "action" && item.show).map(item => ({[item.title]: item.dataIndex }))
            const result = columns_filtered.reduce(function(result, item) {
              let key = Object.keys(item)[0];
              result[key] = item[key];
              return result;
            }, {});
            const {data} = await axios.post('task/query/',{ export: true, columns: result,query:this.$refs.drawer.query.filter((item)=>item.value), limit: 1000 })
            window.open(data.url,'_self')
          }catch (e) {
            this.$message.error('Error in export')
            throw new Error(e)
          }finally {
            this.loadingExport = false
          }
        },

        handleChangeDate(date,i) {
          const due_date = this.form.getFieldValue('due_date')
          if (due_date) {
            this.form.setFieldsValue({ [`reminders[${i}].target_date`]: moment(due_date).subtract(date, 'days').format('YYYY-MM-DD[T]HH:mm:ss') })
          }
        },

      },
      mounted() {
        this.is_click_add_time = true;
        if (this.$route.params.query) {
          this.$refs.task.onSearch(this.$route.params.query)
        }
        else {
          if (this.hasFilterMatter)
            this.$refs.task.query.query = [{ field: 'matter__id',value: this.$route.params.id , condition: '=' }]
          this.$refs.task.fetch()
        }
      },
      created() {
        this.getKanbanList()
        this.model = TableCol.default
      },
    };
</script>

<style>
  @import "../style/style.css";
  .vs-tabs--ul,.vs-tabs-primary .con-ul-tabs .line-vs-tabs{
    box-shadow: none !important;
  }
  [dir] .ant-input{
    border-radius: 3px !important;
  }
  [dir=ltr] .ant-modal-footer{
    display: none !important;
  }
  .task .ant-modal{
    top: 10px !important;
  }
  .ant-tag{
    border-radius: 3px !important;
  }
</style>


